module.exports = __webpack_public_path__ + "media/images/para-bellum-logo-white-90b1e9def5950c9bb3aa4ec32d6443b8.svg";